import HighlightBusinessesPage from "./HighlightBusinessesPage";
import AddHighlightBusinessPage from "./AddHighlightBusinessPage";
import EditHighlightBusinessPage from './EditHighlightBusinessPage';

export {
	HighlightBusinessesPage,
	AddHighlightBusinessPage,
	EditHighlightBusinessPage
};



// WEBPACK FOOTER //
// ./pages/highlight-businesses/index.js